module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/缺省插图-无搜索结果.3c0ca.png";